import { post } from '../index';

export const resetPassword = data => {
  return post('/users/user/reset-password', data);
};
